import React, { Component } from "react";
import Slider from "react-slick";
import PortfolioItem from "./../Portfolio/PortfolioItem";
import { Link } from "react-router-dom";
export default class SliderThreeItem extends Component {
  render() {
    const settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: true,
      autoplaySpeed: 400000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };

    return (
      <>
      <style>{`
      .org-wrapper {
  width: 100%;
}

.org-row {
  display: flex;
  justify-content: center;
  gap: 25px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.org-row .item {
  width: 400px;
}

/* Second row centered */
.second-row {
  justify-content: center;
}

/* Logo PNGs have transparent surrounds — keep containers clear */
.org-wrapper .portfolio-cell,
.org-wrapper .portfolio-item,
.org-wrapper .portfolio-item img {
  background: transparent !important;
  box-shadow: none !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .org-row {
    flex-direction: column;
    align-items: center;
  }

  .org-row .item {
    width: 100%;
    max-width: 370px;
  }
}
      `}</style>
  <div className="org-wrapper">
    
    {/* FIRST ROW */}
    <div className="org-row">
      <div className="item">
        <Link to="/americans4hindus-pac-political-action-committee">
          <PortfolioItem
            portfolioTitle="Americans4Hindus"
            portfolioInfo="PAC - Political Action Committee"
            portfolioSrc="img/preview/blog3.png"
            portfolioAlt="Americans4Hindus"
          />
        </Link>
      </div>

      <div className="item">
        <Link to="/americans4hindus-501c3-nonprofit">
          <PortfolioItem
            portfolioTitle="Americans4Hindus"
            portfolioInfo="501(c)(3) - Non Profit Organization"
            portfolioSrc="img/preview/blog1.png"
            portfolioAlt="Fremont Hindu Temple"
          />
        </Link>
      </div>

      <div className="item">
        <Link to="/dharma-action-council">
          <PortfolioItem
            portfolioTitle="Americans4Hindus"
            portfolioInfo="501(c)(4) - DAC(Dharma Action Council)"
            portfolioSrc="img/preview/blog4.png"
            portfolioAlt="Fremont Hindu Temple"
          />
        </Link>
      </div>
    </div>

    {/* SECOND ROW */}
    <div className="org-row second-row">
      <div className="item">
        <Link to="/festival-of-globe">
          <PortfolioItem
            portfolioTitle="Festival of Globe"
            portfolioInfo="501(c)(3) - Non Profit Organization"
            portfolioSrc="img/preview/blog2.png"
            portfolioAlt="Festival of Globe"
          />
        </Link>
      </div>
    </div>

  </div>
  </>
);
  }
}
